import { render, staticRenderFns } from "./CurrencyDollarIcon.vue?vue&type=template&id=73149e97&"
import script from "./CurrencyDollarIcon.vue?vue&type=script&lang=js&"
export * from "./CurrencyDollarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports